import { atom, selector } from "recoil";
import { roleState } from "./roleState";
import { UserRole } from "@common/utils/graphql";

type BadgeNumber = {
  admin: {
    reports: number;
    stipends: number;
  };
  manager: {
    reports: number;
    stipends: number;
  };
};

export const badgeNumberState = atom<BadgeNumber>({
  key: "badgeNumberState",
  default: {
    admin: {
      reports: 0,
      stipends: 0,
    },
    manager: {
      reports: 0,
      stipends: 0,
    },
  },
});

export const roleHasBadges = (
  role: UserRole,
): role is UserRole.Admin | UserRole.Manager => {
  return role === UserRole.Admin || role === UserRole.Manager;
};

const defaultNavBadgeNumbers = {
  home: 0,
  reports: 0,
  stipends: 0,
  stats: 0,
} as const;

export const navBadgeState = selector({
  key: "navBadgeNumber",
  get: ({ get }) => {
    const pendingBadges = get(pendingBadgeState);
    return {
      ...defaultNavBadgeNumbers,
      ...pendingBadges,
    };
  },
});

export const renderBadgeNumber = (badgeNumber: number) => {
  if (badgeNumber > 20) {
    return "20+";
  }
  return badgeNumber ? `${badgeNumber}` : "";
};

const defaultRoleBadgeState = {
  reports: 0,
  stipends: 0,
} as const;

export const pendingBadgeState = selector({
  key: "pendingBadgeState",
  get: ({ get }) => {
    const role = get(roleState);
    if (roleHasBadges(role)) {
      const badgeState = get(badgeNumberState);
      return badgeState[role];
    }
    return defaultRoleBadgeState;
  },
});

export const pendingReportBadgeState = selector({
  key: "pendingReportBadgeState",
  get: ({ get }) => {
    const { reports } = get(pendingBadgeState);
    return reports;
  },
});

export const pendingStipendsBadgeState = selector({
  key: "pendingStipendsBadgeState",
  get: ({ get }) => {
    const { stipends } = get(pendingBadgeState);
    return stipends;
  },
});
